<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.CopyBusiness')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
  >
    <el-form label-width="120px" label-position="left" style="width: 100%;margin-bottom: 5px">
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item :label="$t('CargoMsg.Cargo_BLNo')">
            <el-input v-model="filter.mbl" />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
            <el-input v-model="filter.jobNo" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <cargo-ag-grid
      config-module="12011502"
      :wrap-text="true"
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
    />
    <cargo-pagination
      v-show="total>0"
      no="pagination"
      config-module="12011502"
      :total="total"
      :page.sync="filter.pageNum"
      :limit.sync="filter.pageSize"
      @pagination="toQuery"
    />
    <span slot="footer">
      <el-button
        type="primary"
        @click="choose()"
      >{{ $t('CargoMsg.Cargo_Select') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getByCondition } from '@/api/seaExport/seaCargoDoc'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'CargoDocExtendCopyDialog',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50,
        mbl: '',
        jobNo: ''
      },
      total: 0,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 150,
        context: {
          componentParent: this
        },
        onRowClicked: this.selectItemClickHandler,
        onRowSelected: this.selectItemClickHandler
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_BLNo'),
          field: 'mbl',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          field: 'shipperInfo',
          width: 200,
          cellRenderer: (params) => ColumnUtils.euBolInfoFormat(params.data, 'shipper')
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          field: 'consigneeInfo',
          width: 200,
          cellRenderer: (params) => ColumnUtils.euBolInfoFormat(params.data, 'consignee')
        }, {
          headerName: this.$t('SeaExport.NotifyParty'),
          field: 'notifyInfo',
          width: 200,
          cellRenderer: (params) => ColumnUtils.euBolInfoFormat(params.data, 'notify')
        }, {
          headerName: this.$t('SeaExport.ActualShipper'),
          field: 'actualShipperInfo',
          width: 200,
          cellRenderer: (params) => ColumnUtils.euBolInfoFormat(params.data, 'actualShipper')
        }, {
          headerName: this.$t('SeaExport.ActualConsignee'),
          field: 'actualConsigneeInfo',
          width: 200,
          cellRenderer: (params) => ColumnUtils.euBolInfoFormat(params.data, 'actualConsignee')
        }
      ],
      selectItem: null,
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
      this.selectItem = null
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.filter.mbl = ''
        this.filter.jobNo = ''
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    selectItemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectItem = event.data
    },
    toQuery() {
      const loading = getLoading4Cxt(this)
      getByCondition(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        this.selectItem = null
        this.gridOptions.api.clearFocusedCell()
        loading.close()
      })
    },
    choose() {
      if (!this.selectItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$emit('selected', this.selectItem)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
